module.exports = __webpack_public_path__ + "static/media/premium_avatar.c1859918.svg";